import {
	Popover,
	PopoverMenu,
	PopoverMenuItem,
} from '@audio-network/componentlibrary'

import { HelpProps } from './Help.types'
import { sendAnalytics } from '@audio-network/analytics'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'

const Help = ({ className, id }: HelpProps): JSX.Element => {
	const { t } = useTranslation(['navigation'])

	const { locale } = useRouter()

	const showBlog = locale.includes('en') || locale.includes('de')

	const handleClick = (noun: string): void => {
		sendAnalytics({
			noun,
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	return (
		<Popover className={className} id={id} mobileCloseLabel={t('close')}>
			<PopoverMenu>
				<PopoverMenuItem
					href="/contact"
					onClick={() => handleClick('Contact us')}
					content={t('contact-us')}
					target="_blank"
				/>

				{showBlog && (
					<PopoverMenuItem
						href="/blog"
						onClick={() => handleClick('Blog')}
						content={t('blog')}
						target="_blank"
					/>
				)}
				<PopoverMenuItem
					href="/privacy"
					onClick={() => handleClick('Privacy')}
					content={t('privacy-and-cookies')}
					target="_blank"
				/>
				<PopoverMenuItem
					href="/terms-and-conditions"
					onClick={() => handleClick('Terms and Conditions')}
					content={t('terms')}
					target="_blank"
				/>
			</PopoverMenu>
		</Popover>
	)
}

export default Help
